import axios from 'axios'

const state = {
  chatTopics: null,
  parentChatTopics: null
}

const actions = {
  fetchProfessionalChatTopics: async ({ commit }, params) => {
    const url = '/beneat/chat-topics'
    const { data } = await axios.get(url)
    if (data.chat_topics) {
      commit('SET_CHAT_TOPICS', data.chat_topics)
    }
  },
  fetchParentChatTopics: async ({ commit, rootState }) => {
    const url = '/topics'
    const selectedAdmins = rootState.conversation.selectedAdmins
    const params = {
      menu: rootState.menu.type,
      admin_id: Array.isArray(selectedAdmins) && selectedAdmins.length
        ? selectedAdmins.map(admin => admin.id)
        : (rootState.conversation.selectedAdmin ? rootState.conversation.selectedAdmin.id : null)
    }
    const { data } = await axios.get(url, { params })
    if (data.topics) {
      commit('SET_PARENT_CHAT_TOPICS', data.topics)
    }
  }
}

const mutations = {
  SET_CHAT_TOPICS: (state, chatTopics) => {
    state.chatTopics = chatTopics
  },
  SET_PARENT_CHAT_TOPICS: (state, topics) => {
    state.parentChatTopics = { ...topics }
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
